import React from 'react';
import Typography from "@material-ui/core/Typography";
import Grid from '@material-ui/core/Grid';
import MaterialTable from "material-table";
import tableicons from "../tableicons";
import Button from "@material-ui/core/Button";
import CreateIcon from "@material-ui/icons/Create";
import DeleteIcon from "@material-ui/icons/Delete";
import {validadorClienteResources} from "../endpoints";
import DialogAgregarEditarValidadorCliente from "../components/DialogAgregarEditarValidadorCliente";
import SnackbarAlert from "../components/SnackbarAlert";
import DialogEliminar from "../components/DialogEliminar";
import StoreIcon from '@material-ui/icons/Store';

class ValidadoresCliente extends React.Component {
    constructor(props) {
        super(props);
        this.state= {
            cargando: true,
            datos: [],
            agregar: false,
            openSnack: false,
            severity: null,
            message: null,
            editar: false,
            eliminar:false,
            validador_cliente: null,
        }
    }

    editarValidador = (rowData) =>{
        this.setState({editar:true, validador_cliente: rowData});
    }

    definirEncargadoTienda = (rowData) =>{
        this.setState({openSnack:false, severity: null, message:null})
        validadorClienteResources.defineEncargadoTienda(rowData.cod_operador).then(async response => {
            if (response) {
                return await response.json();
            }
        }).then(result => {
            if(result) {
                this.refrescar(result.message, result.severity)
            }
            else{
                throw new Error('Something went wrong ...');
            }
        }).catch(error=> {
            console.log(error)
        });
    }

    obtenerValidadorCliente = () =>{
        this.setState({openSnack:false, severity: null, message:null})
        validadorClienteResources.getValidadorCliente().then(async response => {
            if (response) {
                return await response.json();
            }
        }).then(result => {
            if(result.status_code === 200){
                this.setState({cargando:false,datos:result.validadores})
            }
            else if (result.status_code === 401){
                this.setState({cargando:false,openSnack:true, severity:result.severity, message:result.message})
            }
            else{
                throw new Error('Something went wrong ...');
            }
        }).catch(error=> {
            console.log(error)
        });
    }

    handleClose = () =>{
        this.setState({agregar:false,editar:false,eliminar:false})
    }

    refrescar = (estado,severity) =>{
        this.setState({agregar:false,editar:false,eliminar:false, openSnack:false, severity: null, message:null})
        if(severity ==="success"){
            this.obtenerValidadorCliente()
        }
        this.setState({openSnack:true, severity:severity, message:estado})
    }

    eliminarValidador = (row) =>{
        this.setState({eliminar:true, title: "Eliminar validador cliente", content: "Esta acción es irreversible. Está seguro que desea eliminar el validador cliente?", validador_cliente:row})
    }

    componentDidMount() {
        this.obtenerValidadorCliente()
    }

    render() {
        return(
            <div>
                <Typography variant="h4" gutterBottom>Validadores Cliente</Typography>
                <Grid container direction="row" justifyContent="flex-end" alignItems="center" spacing={2} style={{padding:10, marginBottom:10}}>
                    <Grid item>
                        <Button size="large" variant="contained" color="primary" onClick={()=>this.setState({agregar:true,})}>
                            Agregar Validador Cliente
                        </Button>
                    </Grid>
                </Grid>
                <MaterialTable
                    localization={{
                        toolbar: {
                            searchPlaceholder: 'Buscar'
                        },
                        header: {
                            actions: 'Acciones'
                        },
                        body:{
                            emptyDataSourceMessage: 'No hay datos para mostrar'
                        }
                    }}
                    isLoading={this.state.cargando}
                    options={{
                        pageSize: 25,
                        pageSizeOptions: [10, 25, 50, 100],
                        actionsColumnIndex: -1,
                        rowStyle: rowData => ({
                            backgroundColor: (this.state.selectedRow === rowData.tableData.id) ? '#dbe9fc' : '#FFF'
                        }),
                        searchFieldStyle: {
                            width: "auto",
                        },
                        padding: "dense"
                    }}
                    icons={tableicons}
                    title={""}
                    data={this.state.datos}
                    columns={[
                        { title: 'Cód.Usuario', field:'cod_operador' },
                        { title: 'Rut (SD)', field:'rut' },
                        { title: 'Nombre', field: 'nombre1',
                            cellStyle: {
                                width: 200,
                                maxWidth: 200,
                            },
                            headerStyle: {
                                width: 200,
                                maxWidth: 200
                            }},
                        { title: 'Apellido Paterno', field: 'apellido1',
                            cellStyle: {
                                width: 1250,
                                maxWidth: 1250,
                            },
                            headerStyle: {
                                width: 1250,
                                maxWidth: 1250
                        }},
                        { title: 'Apellido Materno', field: 'apellido2',
                            cellStyle: {
                                width: 1250,
                                maxWidth: 1250,
                            },
                            headerStyle: {
                                width: 1250,
                                maxWidth: 1250
                            }},

                    ]}
                    actions={[
                        rowData => ({
                            icon:  () => <StoreIcon style={{fontSize:27, margin:4}}/>,
                            tooltip: 'Definir como encargado de tienda',
                            onClick: (event, rowData) => this.definirEncargadoTienda(rowData),
                            hidden: rowData.encargado
                        }),
                        {
                            icon:  () => <CreateIcon style={{fontSize:27, margin:4}}/>,
                            tooltip: 'Editar Validador',
                            onClick: (event, rowData) => this.editarValidador(rowData),
                        },
                        {
                            icon:  () => <DeleteIcon style={{fontSize:27, margin:4}}/>,
                            tooltip: 'Eliminar Validador',
                            onClick: (event, rowData) => this.eliminarValidador(rowData),
                        }
                    ]}
                    onRowClick={(event, rowData) => this.setState({selectedRow: rowData.tableData.id})}
                />
                {this.state.agregar && <DialogAgregarEditarValidadorCliente validador_cliente={null} refrescar={this.refrescar} handleClose={this.handleClose} />}
                {this.state.editar && <DialogAgregarEditarValidadorCliente validador_cliente={this.state.validador_cliente} refrescar={this.refrescar} handleClose={this.handleClose}/>}
                {this.state.openSnack? <SnackbarAlert severity={this.state.severity} message={this.state.message}/> : null}
                {this.state.eliminar? <DialogEliminar origen={"ValidadorCliente"} refrescar={this.refrescar} id={this.state.validador_cliente.cod_operador} handleClose={this.handleClose} content={this.state.content} title={this.state.title}  />:null}

            </div>

        )
    }
}

export default ValidadoresCliente;